import AnotherJsonValidator from 'ajv';
import { AjvI18n } from './AjvI18n';
import { $ } from '../../simpli';
var AjvController = /** @class */ (function () {
    function AjvController(locale, messages) {
        this.instance = new AnotherJsonValidator({ allErrors: true });
        this.instance.addFormat('date', new RegExp(/\d{4}-\d{2}-\d{2}T00:00:00(?:\.000)?(?:Z?|[-+]?\d{2}(?::\d{2})?)/));
        this.instance.addFormat('datetime', new RegExp(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?(?:Z?|[-+]?\d{2}(?::\d{2})?)/));
        this.instance.addFormat('phone', new RegExp(/^(?:\+?\d{1,3})?(?:\s|-)?(?:\(?\d{2,3}\)?)?(?:\s|-)?\d{3,5}(?:\s|-)?\d{3,5}$/));
        this.instance.addFormat('cpf', new RegExp(/^\d{3}[.]?\d{3}[.]?\d{3}[-]?\d{2}$/));
        this.instance.addFormat('cnpj', new RegExp(/^\d{2}[.]?\d{3}[.]?\d{3}[/]?\d{4}[-]?\d{2}$/));
        this.instance.addFormat('cpfCnpj', new RegExp(/^\d{2,3}[.]?\d{3}[.]?\d{3}[-/]?(?:\d{4}[-])?\d{2}$/));
        this.instance.addFormat('rg', new RegExp(/^\d{1,3}[-.]?\d{1,3}[-.]?\d{1,3}[-.]?\d?$/));
        this.i18n = new AjvI18n(locale, messages);
    }
    AjvController.prototype.validateErrors = function (schemaKeyRef, data) {
        this.instance.validate(schemaKeyRef, data);
        var errors = this.instance.errors || null;
        if (errors) {
            $.ajv.i18n.translate(errors);
        }
        return errors;
    };
    AjvController.prototype.validate = function (schemaKeyRef, data) {
        var errors = this.validateErrors(schemaKeyRef, data);
        if (errors)
            throw errors;
    };
    return AjvController;
}());
export { AjvController };
//# sourceMappingURL=AjvController.js.map